import store from "@/store";

export function clearFormFieldErrors(formFields) {
  for (let field in formFields) {
    let data = {};
    data[field] = "";
    store.commit("core/setError", data);
  }
}
